<template>
  <div class="corp-cert-apply overflowHidden">
    <myheader :backIntercept="true" @childBackEvent="back" headTitle="证书申请"></myheader>
    <div class="all_main flex-column">
      <div class="content-box">
        <van-icon name="clock-o" size="3rem" color="#f7b500" />
        <div class="text14 margin_top_5">CA证书申请提交成功</div>
        <div class="text12 margin_top_5">CA机构将在48小时内进行审核，请留意短信提醒！</div>
        <div class="text12 margin_top_5">审核通过后请在证书管理中下载数字证书！</div>
        <div class="text12 margin_top_5">如有证书办理问题，请咨询：4009199000转3！</div>
      </div>
      <div class="all_tips_bottom_card">
        <button class="all_button22 width_100 text16 bmain_active" @click="back">关闭</button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Icon,

} from 'vant';
import {closeCurrentPage} from '../../utils/nativeOtherOperate.js'
export default {
  components: {
    [Icon.name]: Icon,
  },
  data() {
    return {

    }
  },
  created() {

  },
  mounted() {

  },
  methods: {

    back() {    // 返回
      if (this.$route.query.appCode) {
        closeCurrentPage()
      } else {
        this.$router.go(-2)
      }
    },
  },
  beforeDestroy() {
    //自动回收
  }
}
</script>

<style scoped lang="scss">
@import "../../styles/global.css";
  .content-box{
    background: #fff;
    border-radius: .2rem;
    margin:.5rem;
    padding:1rem .5rem;
    text-align: center;
  }

</style>
